import { render, staticRenderFns } from "./IconConversation.vue?vue&type=template&id=195b21a9&"
import script from "./IconConversation.vue?vue&type=script&lang=js&"
export * from "./IconConversation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports